








import Vue, {PropType} from 'vue'
import {Observer} from 'mobx-vue'

import {UtilityItem} from '../../stores/UtilityBar'

export default Observer(Vue.extend({
    props: {
        item: Object as PropType<UtilityItem>
    }
}))
